import { ref, computed } from 'vue'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import clsHttp from '@/app/clsHttp'

const connectionState = ref('initialized')
const lastError = ref(null)
const joinedChannels = ref(new Set())

function createEcho() {
    var http = new clsHttp(false);  // http without default error handler.

    // window.Pusher = Pusher

    var echoConfig = {
        broadcaster: 'reverb',
        
        key: process.env.VUE_APP_REVERB_APP_KEY,
        wsHost: process.env.VUE_APP_REVERB_HOST,
        wsPort: Number(process.env.VUE_APP_REVERB_PORT),
        wssPort: Number(process.env.VUE_APP_REVERB_PORT),
        forceTLS: process.env.VUE_APP_REVERB_SCHEME === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: `${process.env.VUE_APP_BASEURL}/api/broadcasting/auth`,

            // Instead of the default authorizer, we want  to use our own, so that 
            // the correct authorization headers are sent along with the request. 
            // Also, we 'hide' the error message when subscription fails as users are not aware of the channels 
            // and will often not care about the 'internals'.
            // We may decide in a later stage that we might do anything with the erros. 
            // E.g. showing a snackbar, or sending to the server on the next request so that we can analyze more.
            authorizer: (channel, options) => {
                return {
                    authorize: (socketId, callback) => {
    //                    console.log('Authorizing channel', channel.name, 'with socketId', socketId)
                        http.post('/api/broadcasting/auth', {
                            socket_id: socketId,
                            channel_name: channel.name,
                        }, {

                        })
                        .then(response => {
    //                        console.log('Authorizing channel then', response)
                            callback(false, response.data)
                        })
                        .catch(error => {
    //                        console.log('Authorizing channel error', error)
                            callback(true, error)
                        })
                    }
                }
            }
    };

    return new Echo(echoConfig)
}

function bindConnectionEvents(connection) {
    connection.bind('connected', () => {
        console.log('Echo connected');
        connectionState.value = 'connected'
        lastError.value = null
    })

    connection.bind('connecting', () => {
        console.log('Echo connecting');
        connectionState.value = 'connecting'
    })

    connection.bind('unavailable', () => {
        console.log('Echo unavailable');
        connectionState.value = 'unavailable'
    })

    connection.bind('disconnected', () => {
        console.log('Echo disconnected');
        connectionState.value = 'disconnected'
    })

    connection.bind('error', (error) => {
        console.log('Echo error', error);
        lastError.value = error
    })

    connection.bind('state_change', (states) => {
        console.log('Echo state change', states);
        connectionState.value = states.current
    })
}


let echo = null;

const isConnected = computed(() => connectionState.value === 'connected')
const isReconnecting = computed(() =>
    ['connecting', 'unavailable'].includes(connectionState.value)
)
const activeChannelCount = computed(() => joinedChannels.value.size)

function trackChannel(name) {
    console.log('Tracking channel', name);
    const next = new Set(joinedChannels.value)
    next.add(name)
    joinedChannels.value = next
}

function untrackChannel(name) {
    const next = new Set(joinedChannels.value)
    next.delete(name)
    joinedChannels.value = next
}

function joinPublic(name) {
    trackChannel(name)
    return echo.channel(name)
}

function joinPrivate(name) {
    trackChannel(name)
    return echo.private(name)
}

function joinPresence(name) {
    trackChannel(name)
    return echo.join(name)
}

function leave(name) {
    echo.leave(name)
    untrackChannel(name)
}

function leaveAll() {
    Array.from(joinedChannels.value).forEach((name) => {
        echo.leave(name)
    })
    joinedChannels.value = new Set()
}

function echoDump() {
    console.dir({
        channels: joinedChannels.value,
        connectionState: connectionState.value
    })
}
function getSocketId() {
    if (!echo) {
        return null;
    }
    return echo.socketId();
}

function useEcho() {
    if (!echo) {
        echo = createEcho();
        bindConnectionEvents(echo.connector.pusher.connection);     
        window.echo = echo;   
    }

    return {
        echo,
        connectionState,
        isConnected,
        isReconnecting,
        lastError,
        activeChannelCount,
        joinedChannels,
        joinPublic,
        joinPrivate,
        joinPresence,
        leave,
        leaveAll,
        echoDump,
        getSocketId,
    }

}

window.echoDump = echoDump

export default useEcho;